export const helixDark = {
  name: 'onify:helix-dark',
  extends: 'onify:helix',
  cssPath: 'css/helix-dark',
  vuetify: {
    theme: {
      dark: true,
      colors: {
        background: '#1C1B1E',
        'on-background': '#E6E1E6',
        surface: '#141316',
        'surface-variant-2': '#141316',
        'surface-variant-3': '#141316',
        'on-surface': '#CAC5CA',
        'on-primary-container': '#E6E1E6',
        neutral: '#1C1B1E',
        'neutral-100': '#141316',
        'on-neutral-100': '#CAC5CA',
        'workspace-bulletin': '#141316',
      },
    },
  },
};
